var map = {
	"./bg-lines.svg": 72147,
	"./bloomberg-opinion1.svg": 85539,
	"./bloomberg1.svg": 14956,
	"./bookmark.svg": 58552,
	"./bqprime-grey.svg": 69784,
	"./bqprime-social-charcoal.svg": 67740,
	"./bqprime-subscription.svg": 71966,
	"./bqprime.svg": 18952,
	"./close-circular-border.svg": 15065,
	"./close.svg": 62428,
	"./close_brown.svg": 34369,
	"./cross.svg": 86416,
	"./exclusive.svg": 34576,
	"./google.svg": 80005,
	"./ic_binoculars.svg": 97485,
	"./ic_copy.svg": 35292,
	"./ic_dice.svg": 45114,
	"./ic_expand_box_gradient.svg": 28288,
	"./ic_play_circle_filled.svg": 64411,
	"./light-house.svg": 80055,
	"./loading.svg": 56372,
	"./logo.svg": 41021,
	"./question.svg": 57044,
	"./tick-with-border.svg": 8715,
	"./undo-bookmark-hover.svg": 97070,
	"./undo-bookmark.svg": 35783,
	"./wazirx.svg": 21977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61139;